import {
  IWedding_Website_Section,
  IWedding_Website_Section_PhotosField,
} from '@bridebook/models/source/models/Weddings.types';

export const isPhotoWeddingSection = (
  section: IWedding_Website_Section,
): section is IWedding_Website_Section_PhotosField => section.type === 'PhotosField';
